import { render, staticRenderFns } from "./PayoutDetailDownload.vue?vue&type=template&id=c2ca1b76&scoped=true"
import script from "./PayoutDetailDownload.vue?vue&type=script&lang=js"
export * from "./PayoutDetailDownload.vue?vue&type=script&lang=js"
import style0 from "./PayoutDetailDownload.vue?vue&type=style&index=0&id=c2ca1b76&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ca1b76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2ca1b76')) {
      api.createRecord('c2ca1b76', component.options)
    } else {
      api.reload('c2ca1b76', component.options)
    }
    module.hot.accept("./PayoutDetailDownload.vue?vue&type=template&id=c2ca1b76&scoped=true", function () {
      api.rerender('c2ca1b76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/customer-service/components/PayoutDetailDownload.vue"
export default component.exports